import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from '~/i18n/locales/en/common.json'
import enPage from '~/i18n/locales/en/page.json'
import common from '~/i18n/locales/ja/common.json'
import page from '~/i18n/locales/ja/page.json'

/**
 * localStorage キー。
 * テーマの `ebalance-theme` と同パターンで first-paint 用に言語をキャッシュする。
 * SoT は session RPC の表示言語（メンバーの eCloud 個人設定の言語。未設定なら組織言語）、
 * localStorage はあくまでキャッシュ。
 */
export const LANG_STORAGE_KEY = 'ebalance-lang'

/**
 * localStorage キャッシュから前回の言語を読む（無ければ 'ja'）。
 * first-paint で同期 init するために呼ぶ。
 */
function getCachedLang(): string {
  try {
    return localStorage.getItem(LANG_STORAGE_KEY) ?? 'ja'
  } catch {
    return 'ja'
  }
}

/**
 * localStorage に言語をキャッシュする。
 * SoT は session RPC で取得した表示言語（`display_language`）。
 */
export function setCachedLang(lang: string): void {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang)
  } catch {
    // localStorage 不可環境では silent ignore
  }
}

export function initI18n(): void {
  // localStorage キャッシュ（前回の表示言語、無ければ 'ja'）で同期 init する。
  // これにより en 表示のユーザーは初回以降 FOUC なしで英語 first-paint できる。
  // session RPC 取得後に表示言語で changeLanguage + setCachedLang を呼ぶ（I18nProvider）。
  const cachedLng = getCachedLang()

  void i18n.use(initReactI18next).init({
    resources: {
      ja: {
        common,
        page,
      },
      en: {
        common: enCommon,
        page: enPage,
      },
    },
    lng: cachedLng,
    fallbackLng: 'ja',
    supportedLngs: ['ja', 'en'],
    ns: ['common', 'page'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  })
}
